import { Notify } from 'vant'
import wx from 'weixin-js-sdk'
import { commonConfig, getConfig, getCityByCoord, getCityByIp } from '@/api/api'
import { readCityCache, writeCityCache } from './cityCache'

const TIMEOUT = 8000
const FAIL_TIP = '获取定位失败，请自行选择城市'

let inFlight = null

const cityResult = (city) => ({ data: { city: city || '' }})

// 定位结果上报，供运营统计使用（未命中城市则不报）
const reportLocation = (city) => {
  if (!city) return
  getConfig({ locationType: 1, location: city }).catch(() => {})
}

// IP 兜底：由后端统一服务完成，服务端有缓存，不直接消耗高德配额
async function requestCityByIp() {
  try {
    const { data } = await getCityByIp()
    return (data && data.city) || ''
  } catch (e) {
    console.warn('[location] IP 兜底失败', e)
    return ''
  }
}

// 坐标转城市：由后端统一服务完成（含坐标归一、网格缓存、配额熔断）
async function requestCityByCoord(longitude, latitude) {
  const { data } = await getCityByCoord({
    lng: longitude,
    lat: latitude,
    coordType: 'wgs84'
  })
  return (data && data.city) || ''
}

const requestLocation = () => new Promise((resolve) => {
  let done = false
  let timer = null

  const finish = (city, tip) => {
    if (done) return
    done = true
    if (timer) clearTimeout(timer)
    inFlight = null
    if (city) writeCityCache(city)
    if (tip) Notify(tip)
    resolve(cityResult(city))
  }

  async function fallback(tip) {
    if (done) return
    const city = await requestCityByIp()
    finish(city, city ? '' : tip)
  }

  timer = setTimeout(() => fallback('定位超时，请自行选择城市'), TIMEOUT)

  commonConfig({ url: location.href.split('#')[0] })
    .then(({ data: config }) => {
      if (done || !config) {
        fallback(FAIL_TIP)
        return
      }
      wx.config({
        debug: false,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['getLocation']
      })
      wx.error(() => {
        console.warn('[location] wx.config 校验失败')
        fallback(FAIL_TIP)
      })
      wx.ready(() => {
        if (done) return
        wx.getLocation({
          type: 'wgs84',
          success: ({ latitude, longitude }) => {
            requestCityByCoord(longitude, latitude)
              .then((city) => {
                if (done) return
                if (city) {
                  reportLocation(city)
                  finish(city)
                } else {
                  fallback(FAIL_TIP)
                }
              })
              .catch((e) => {
                console.warn('[location] 坐标转城市失败', e)
                fallback(FAIL_TIP)
              })
          },
          fail: () => fallback(FAIL_TIP)
        })
      })
    })
    .catch((e) => {
      console.warn('[location] 获取微信签名失败', e)
      fallback(FAIL_TIP)
    })
})

export const getLocation = () => {
  if (inFlight) return inFlight
  const cached = readCityCache()
  if (cached) return Promise.resolve(cityResult(cached))
  inFlight = requestLocation()
  return inFlight
}
